// extracted by mini-css-extract-plugin
export default {"checkbox":"_9gN1B","align-items-center":"_3AK8V","alignItemsCenter":"_3AK8V","label":"_3PA7e"};